module.exports = __webpack_public_path__ + "static/media/ssl.1a13b2fd.svg";